export default "__VITE_ASSET__9J6mVq3d__"